import moment from 'moment';

export function fillMissingDates(data) {
    if (!Array.isArray(data) || !data?.length) return [];
    // Sort data by date (just in case)
    data.sort((a, b) => formatDate(a.date.value) - formatDate(b.date.value));

    let filledData = [];
    let currentDate = formatDate(data[0]?.date?.value); // Start from the earliest date
    const lastDate = formatDate(data?.[data.length - 1]?.date?.value);
    let index = 0;
    if (!currentDate || !lastDate) return [];
    while (currentDate <= lastDate) {
        // let dateStr = currentDate.toISOString().split('T')[0]; // Format YYYY-MM-DD
        let dateStr = moment(currentDate).format('YYYY-MM-DD'); // Format YYYY-MM-DD

        if (index < data.length && data[index].date.value === dateStr) {
            filledData.push(data[index]); // Add existing entry
            index++;
        } else {
            // Insert missing date entry
            let newEntry = {};
            Object.keys(data[0]).forEach((key) => {
                if (key === 'date') {
                    newEntry[key] = { value: dateStr }; // Set correct date
                } else {
                    newEntry[key] = null; // Assign null for all other keys
                }
            });

            filledData.push(newEntry);
        }
        currentDate.setDate(currentDate.getDate() + 1); // Move to next day
    }

    return filledData;
}

function formatDate(date) {
    try {
        const [year, month, day] = date.split('-').map(Number);
        return new Date(year, month - 1, day);
    } catch (err) {
        return new Date(date);
    }
}
